var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{class:['c-toasts', 'c-toasts--top-right', _vm.isRepositioned],attrs:{"name":"toasts","tag":"div"}},_vm._l((_vm.toasts),function(toast){return _c('toast',{key:toast.id,staticClass:"toasts-item",attrs:{"toast":toast}})}),1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a02c180","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/app/plugins/toasts/Toasts.vue
// module id = 266
// module chunks = 65